import {
  defaultAppLocale,
  defaultDirection,
  localeOptions,
} from '../constants/defaultValues';

 
export const getDirection = () => {
  let direction = defaultDirection;

  try {
    if (localStorage.getItem('direction')) {
      const localValue = localStorage.getItem('direction');
      if (localValue === 'rtl' || localValue === 'ltr') {
        direction = localValue;
      }
    }
  } catch (error) {
    console.error('>>>>: src/helpers/Utils.js : getDirection -> error', error);
    direction = defaultDirection;
  }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};
 
export const setDirection = (localValue) => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  try {
    localStorage.setItem('direction', direction);
  } catch (error) {
    console.error('>>>>: src/helpers/Utils.js : setDirection -> error', error);
  }
};

 
export const getCurrentLanguage = () => {
  // 1) Start with default
  let resolved = defaultAppLocale;

  // 2) Respect user preference saved in localStorage, but only if supported
  try {
    const saved = localStorage.getItem('currentLanguage');
    if (saved && localeOptions.some((x) => x.id === saved)) {
      return saved;
    }
  } catch (error) {
    console.error('>>>>: src/helpers/Utils.js : getCurrentLanguage (read saved) -> error', error);
  }

  // 3) Build a case-insensitive lookup of supported IDs from localeOptions
  const supportedIds = localeOptions.map((x) => x.id); // e.g. ['en','de','zh-CN',...]
  const supportedLookup = supportedIds.reduce((acc, id) => {
    acc[id.toLowerCase()] = id; // normalize to lowercase for comparison, keep original for return
    return acc;
  }, {});

  // 4) Gather browser-preferred languages (most preferred first)
  const browserLangs = (
    (Array.isArray(navigator.languages) && navigator.languages.length > 0)
      ? navigator.languages
      : [navigator.language || navigator.userLanguage]
  ).filter(Boolean);

  // 5) Try to resolve:
  //    a) Exact match (case-insensitive) against supported IDs (e.g., 'zh-CN')
  //    b) Primary subtag match against supported IDs (e.g., 'de-DE' -> 'de')
  //    c) If primary isn't directly supported, try first supported id that starts with `${primary}-` (e.g., 'zh' -> 'zh-CN')
  for (const lang of browserLangs) {
    const lower = lang.toLowerCase();
    // a) exact
    if (supportedLookup[lower]) {
      resolved = supportedLookup[lower];
      break;
    }
    // b) primary subtag
    const primary = lower.split('-')[0];
    if (supportedLookup[primary]) {
      resolved = supportedLookup[primary];
      break;
    }
    // c) pick first supported that starts with primary-
    const regionalFallback = supportedIds.find((id) => id.toLowerCase().startsWith(primary + '-'));
    if (regionalFallback) {
      resolved = regionalFallback;
      break;
    }
  }

  return resolved;
};
 
export const setCurrentLanguage = (locale) => {
  try {
    localStorage.setItem('currentLanguage', locale);
  } catch (error) {
    console.error('>>>>: src/helpers/Utils.js : setCurrentLanguage -> error', error);
  }
};

export const updateMultilingualJson = (currentJson, newString, currentLanguage) => {

  const newMultilingualJson = { ...currentJson };
  newMultilingualJson[currentLanguage] = newString;

  // add defaultLocale key in case it does not exist yet
  // replace it with English in case user is adding English
  if (!newMultilingualJson['defaultLocale'] || currentLanguage === 'en') {
    newMultilingualJson['defaultLocale'] = currentLanguage;
  }

  return newMultilingualJson;
};

export const getPictureLocaleUrl = (pictureurl) => {
  let url = '';
  const currentLang = getCurrentLanguage();
  try {
    url = pictureurl[currentLang]
      ? pictureurl[currentLang]
      : pictureurl[pictureurl['defaultLocale']];
  } catch {
    // no need to catch this
  }
  return url;
};

export const getSameDay = (startTime, endTime) => {
  startTime = new Date(startTime);
  endTime = new Date(endTime);
  return (
    startTime.getFullYear() === endTime.getFullYear() &&
    startTime.getMonth() === endTime.getMonth() &&
    startTime.getDate() === endTime.getDate()
  );
};

export const getHours = (startTime, endTime) => {
  startTime = new Date(startTime);
  endTime = new Date(endTime);
  const duration = ((endTime - startTime) / 3600000);
  return (Math.round(duration) !== duration)
    ? duration.toFixed(2)
    : duration;
};

 
